import { Modal } from 'components/common';
import { QuickMenuSection } from './types';
import QuickMenuView from './QuickMenuView';

interface QuickMenuModalProps {
  isOpen: boolean;
  onHide: () => void;
  menus: QuickMenuSection[];
}

const QuickMenuModal = ({
  isOpen,
  onHide,
  menus,
}: QuickMenuModalProps) => {
  return (
    <Modal open={isOpen} onHide={onHide} isShowCloseButton={true}>
      <div className="tw-flex tw-flex-col tw-gap-8 tw-p-8 tw-max-h-[680px] tw-overflow-y-auto">
        {menus.map(({ title, menus }) => (
          <QuickMenuView key={title} title={title} menus={menus} />
        ))}
      </div>
    </Modal>
  );
};

export default QuickMenuModal;
